import { useState } from "react";

import BottomMobileOptionsModal from "@/components/bottom-mobile-options-modal";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";

import useToggleUserBlock from "../hooks/use-toggle-user-block";
import type { UserType } from "../types";
import { UserProfileOptions } from "./modal-button";
import ReportedModal, { useReportedModal } from "./reported-modal";

interface BlockedButtonProps {
  label: string;
  user: UserType;
}

export default function BlockedButton({ label, user }: BlockedButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isDesktop = useIsBreakPoint("md");

  const toggleUserBlock = useToggleUserBlock(user);
  const [isReportedModalOpen, setIsReportedModalOpen] = useReportedModal();

  const handleBlockUser = () => toggleUserBlock();

  return (
    <>
      <Popover onOpenChange={setIsMenuOpen} open={isMenuOpen}>
        <PopoverTrigger className="h-[45px] w-full rounded-[23px] bg-carmine font-medium text-14 text-white shadow-cardinal transition-shadow hover:shadow-0-0-10-5">
          {label}
        </PopoverTrigger>
        {isDesktop ? (
          <PopoverContent className="flex w-auto min-w-72 flex-col items-stretch gap-2.5 rounded-[15px] border-0 bg-space-gray-dark p-2.5 shadow-0-0-8 shadow-black/25">
            <UserProfileOptions
              isMenu
              isOpen={isMenuOpen}
              onBlock={handleBlockUser}
              onClose={() => setIsMenuOpen(false)}
              onReport={() => setIsReportedModalOpen(true)}
              user={user}
            />
          </PopoverContent>
        ) : (
          <BottomMobileOptionsModal
            onOpenChange={setIsMenuOpen}
            open={isMenuOpen}
            title="Have an issue?"
          >
            <ul className="flex flex-col items-stretch gap-1.5">
              <UserProfileOptions
                isOpen={isMenuOpen}
                onBlock={handleBlockUser}
                onClose={() => setIsMenuOpen(false)}
                onReport={() => setIsReportedModalOpen(true)}
                user={user}
              />
            </ul>
          </BottomMobileOptionsModal>
        )}
      </Popover>
      <ReportedModal
        onOpenChange={setIsReportedModalOpen}
        open={isReportedModalOpen}
      />
    </>
  );
}
